exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container[data-v-f49831f6]{overflow-y:scroll}\n", ""]);

// exports
